import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=47403079"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"
import style0 from "./Conference.vue?vue&type=style&index=0&id=47403079&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports